var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import getKeyValueFromQueryString from './imports/getKeyValueFromQueryString';
if (window.location.href.indexOf('/auth/success') !== -1 ||
    window.location.href.indexOf('/auth/failure') !== -1) {
    var token = getKeyValueFromQueryString('token');
    if (token) {
        window.localStorage.setItem('crimp-jwt', token);
        window.close();
        window.location.replace(process.env.CLIENT_PLATFORM_URL);
    }
}
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, combineReducers, compose, createStore, } from 'redux';
import { ConnectedRouter, routerReducer, routerMiddleware, } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
import thunk from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import * as Raven from 'raven-js';
import feathersClient, { feathersServices, feathersAuthentication, } from './feathers';
import * as reducers from './reducers';
import './imports/styles/antd.index.css';
import './imports/styles/styles.fonts.scss';
import './imports/styles/styles.main.scss';
Raven.config(process.env.NODE_ENV === 'production' ? 'https://fa809a8d1aa94861baf863aafa343aef@sentry.io/298635' : '', {
    environment: process.env.NODE_ENV,
}).install();
import App from './app';
window.feathersClient = feathersClient;
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
var rootReducer = combineReducers(__assign({}, reducers, { auth: feathersAuthentication.reducer, router: routerReducer, services: combineReducers({
        users: feathersServices.users.reducer,
        userProfiles: feathersServices.userProfiles.reducer,
        userOrganizationRoles: feathersServices.userOrganizationRoles.reducer,
        userEventRoles: feathersServices.userEventRoles.reducer,
        organizations: feathersServices.organizations.reducer,
        events: feathersServices.events.reducer,
        categories: feathersServices.categories.reducer,
        rounds: feathersServices.rounds.reducer,
        routes: feathersServices.routes.reducer,
        roundBibs: feathersServices.roundBibs.reducer,
        teams: feathersServices.teams.reducer,
        teamScores: feathersServices.teamScores.reducer,
        athletes: feathersServices.athletes.reducer,
        athleteScores: feathersServices.athleteScores.reducer,
        athleteScoreRoutes: feathersServices.athleteScoreRoutes.reducer,
        athleteScoreRouteHistories: feathersServices.athleteScoreRouteHistories.reducer,
        actives: feathersServices.actives.reducer,
        notifications: feathersServices.notifications.reducer,
    }) }));
var history = createHistory();
var store = createStore(rootReducer, composeEnhancers(applyMiddleware(routerMiddleware(history), thunk, promiseMiddleware())));
ReactDOM.render(React.createElement(Provider, { store: store },
    React.createElement(ConnectedRouter, { history: history },
        React.createElement(App, null))), document.getElementById('root'));



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 470
// module chunks = 0